import { EPGRegionSelector } from './EPGRegionSelector';

export default EPGRegionSelector;
